import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { BrowserModule } from '@angular/platform-browser';
import { BannerComponent } from './banner.component';

@NgModule({
  declarations: [BannerComponent],
  exports: [BannerComponent],
  imports: [BrowserModule, MatIconModule],
  bootstrap: [BannerComponent],
})
export class BannerModule {}
